<script>
   import Layout from '../../layouts/main'
   import PageHeader from '@/components/page-header'
   import appConfig from "@/app.config";
    
   export default {
      page: {
         title: "Symptoms",
         meta: [
            {
               name: "description",
               content: appConfig.description,
            },
         ],
      },
      components: { Layout, PageHeader },
      data() {
         return {
            title: "Sub Questions",
            items: [
               {
                  text: "Doctors",
                  href: "/doctors",
               },   
               {
                  text: "Symptoms",
                  active: true,
               },                   
            ],

            symptoms: [],
            symptom: {
               id: null,
               question : "",
               title: "Symptoms",
            },
            
            modal_title: "Add Sub Question",
            button_title: "Save",
            pagination: {},
            edit: false,
            question_status: {
               id: "",
               status: "",
            },
            keyword: "",
            listing_length: 10,
            status: '',
            token: "",
            errors: {},
            activate: false,
            deactivate: false,
            sub_questions:[],
            question:"",
            active_page_url: null,
         };
      },
      mounted() {
    
      },
      created() {
         this.fetchQuestions();
      },

      methods: {
         fetchQuestions(page_url = null) {
            this.getToken();
            let url = "api/admin/doctor/symptom_sub_questions?question_id=" + this.$route.params.id;

            page_url = page_url || url;

            if(localStorage.back_url) {
               page_url = localStorage.back_url;  
               localStorage.removeItem('back_url');
            }    

            this.active_page_url = page_url;
            this.loading = true;

            this.$axios
               .get(page_url, { headers: { Authorization: "Bearer " + this.token } })
               .then((res) => {
                  var responseData = res.data.data;
                  console.log(responseData);
                  this.sub_questions = responseData.sub_questions;
                  this.question = responseData.question;
                  console.log(this.question);
            })
            .catch((error) => {
                  if (error.response) {
                     if (error.response.data.message) {
                        if(typeof error.response.data.message === 'object') {
                           console.log(error.response.status);
                        } else {
                           this.$swal("", error.response.data.message, "error");
                        }                        
                        
                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
            })
            .finally(() => (this.loading = false));
         },
            getToken() {
               if (localStorage.getItem('medicino_admin')) {
                  var medicino_admin =  JSON.parse(localStorage.getItem('medicino_admin'));
                  if(medicino_admin.token) {
                     this.token = medicino_admin.token;
                  } else {
                     this.$swal("", "Failed to fetch token, please login again", "error");
                     this.$router.push({ name: "login" });
                  }
                  
               } else {
                  this.$swal("", "Session expired, please login again", "error");
                  this.$router.push({ name: "login" });
               }
            }, 
            addQuestion() {
               this.getToken();           
               
               const config = {
                  headers: {
                     "Content-type": "application/json",
                     "Accept": "application/json",
                     "Authorization": "Bearer " + this.token,
                  },
               };
               let url;
               let formData = new FormData();
               formData.append("question", this.symptom.question); 
      
               if(!this.edit) {
                  url = "api/admin/doctor/symptom_subquestion_add";
                  formData.append("question_id", this.$route.params.id); 

                  this.active_page_url = null;
               } else {
                  url = "api/admin/doctor/symptom_subquestion_edit";
                  formData.append("sub_question_id", this.question.id); 
               } 
               this.$axios
               .post(url, formData, config)
               .then((response) => {
                  if (response.data.status) {
                     this.$swal("", response.data.message, "success");
                  } else {
                     this.$swal("", response.data.message, "error");
                  }
                  this.hideModal('symptom-modal');
                  this.fetchQuestions(this.active_page_url);
               })
               .catch((error) => {
                  if (error.response) {
                     if (error.response.data.message) {
                        this.errors = error.response.data.message;
                        // console.log(this.errors);
                        this.$swal("", error.response.data.message, "error");
                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
               })
               .finally(() => (this.loading = false));
         },
         activateQuestion(question) {
            this.activate = false;
              this.$bvModal.msgBoxConfirm('Are you sure you want to publish this Question?', {
                  title: 'Confirm',
                  size: 'sm',
                  buttonSize: 'sm',
                  okVariant: 'danger',
                  okTitle: 'Yes',
                  cancelTitle: 'No',
                  footerClass: 'p-2',
                  hideHeaderClose: false,
                  centered: true
              })
              .then(value => {
                  this.activate = value
                  if(this.activate){
                  this.question_status.id = question.id;
                  this.question_status.status = 1;
                  this.updateQuestionStatus();
               }
              })
               .catch(err => {
                  console.log(err);
              })
         },
         deactivateQuestion(question) {
            this.deactivate = false;
              this.$bvModal.msgBoxConfirm('Are you sure you want to unpublish this Question?', {
                  title: 'Confirm',
                  size: 'sm',
                  buttonSize: 'sm',
                  okVariant: 'danger',
                  okTitle: 'Yes',
                  cancelTitle: 'No',
                  footerClass: 'p-2',
                  hideHeaderClose: false,
                  centered: true
              })
               .then(value => {
                  this.deactivate = value
                  if(this.deactivate){
                  this.question_status.id = question.id;
                  this.question_status.status = 2;
                  this.updateQuestionStatus();
               }
               })
               .catch(err => {
                  console.log(err);
               })
         },
         updateQuestionStatus() {
            
            this.getToken();
            const config = {
               headers: {
                  "Content-type": "application/json",
                  "Accept": "application/json",
                  "Authorization": "Bearer " + this.token,
               },
            };     

            let url = "api/admin/doctor/symptoms_subquestion_status?sub_question_id=" + this.question_status.id + "&status=" + this.question_status.status;

            this.$axios
               .get(url,config)
               .then((response) => {                  
                  if (response.data.status) {
                     this.$swal("", response.data.message, "success");
                  } else {
                     this.$swal("", response.data.message, "error");
                  }
                  this.fetchQuestions(this.active_page_url);
               })
               .catch((error) => {                
                  if (error.response) {
                     if (error.response.data.message) {
                        this.$swal("", error.response.data.message, "error");
                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
               });
         }, 
         showModal(modal) {
            this.$refs[modal].show();
         },

         hideModal(modal) {
            this.$refs[modal].hide();
         },

         editQuestion(question) {            
            this.modal_title = "Edit Subquestion";
            this.button_title = "Update";
            this.symptom.question = question.sub_question; 
            this.question.id = question.id;
            this.edit = true;
            this.showModal("symptom-modal");
         },
         removeQuestion(id) {
            this.delete = false;
            this.$bvModal.msgBoxConfirm('Are you sure you want to delete this question?', {
                  title: 'Confirm',
                  size: 'sm',
                  buttonSize: 'sm',
                  okVariant: 'danger',
                  okTitle: 'Yes',
                  cancelTitle: 'No',
                  footerClass: 'p-2',
                  hideHeaderClose: false,
                  centered: true
            })
            .then(value => {
               this.delete = value
               if(this.delete){
                  this.getToken();           
            
                  const config = {
                     headers: {
                        "Content-type": "application/json",
                        "Accept": "application/json",
                        "Authorization": "Bearer " + this.token,
                     },
                  };
                 
                  let url = "api/admin/doctor/symptoms/subquestion_remove?sub_question_id=" + id;
                  this.$axios
                  .get(url, config)
                  .then((response) => {
                        if (response.data.status) {
                           this.$swal("", response.data.message, "success");
                        } else {
                           this.$swal("", response.data.message, "error");
                        }
                        this.fetchQuestions(this.active_page_url);
                  })
                  .catch((error) => {
                     if (error.response) {
                        if (error.response.data.message) {
                           this.errors = error.response.data.message;
                           //console.log(this.errors);
                        } else {
                           this.$swal("", "Something went wrong", "error");
                        }
                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
                  })
                  .finally(() => (this.loading = false));
               }
            })
            .catch(err => {
               console.log(err);
            })
         },
         clearForm() {           
            
            this.modal_title = "Add Question";
            this.button_title = "Save";
            this.symptom.question = "";           
            this.edit = false;
            this.errors = {};
         },
      }
   }
</script>
    
<template>
   <Layout>
      <PageHeader :title="title" :items="items" />
      <div class="row">
         <div class="col-12">
            <div class="card">
               <div class="card">
                  <div class="card-body">
                     <!----- filters area starts---->
                     <div class="row">
                        <h4>{{question.question}}</h4>
                        
                     </div>
                     <b-button v-b-modal.symptom-modal variant="primary" class="float-end btn btn-sm me-2 mb-2">Add</b-button>


                  </div>
            </div>
            <div class="card-body">
            <div class="table-responsive">
                     <table class="table table-bordered mb-0">
                        <thead class="table-light">
                           <tr>
                              <th>Sub Questions</th> 
                              <th>Created On</th>
                              <th>Options</th>
                           </tr>
                        </thead>
                        <tbody v-if="Boolean(sub_questions.length)">
                           <tr v-for="(question) in sub_questions" :key="question.id">
                              <td>{{question.sub_question}}</td>
                              <td>{{question.converted_created_at }}</td>
                              <td>

                                 <b-button variant="primary" class="btn btn-sm me-2 mb-2" @click="editQuestion(question)">Edit</b-button>
                                
                                 <b-button v-if="question.status==1" variant="danger" class="btn btn-sm me-2 mb-2" @click="deactivateQuestion(question)">Unpublish</b-button>

                                 <b-button v-else variant="success" class="btn btn-sm me-2 mb-2" @click="activateQuestion(question)">Publish</b-button>                                     
                                 <b-button  variant="danger" class="btn btn-sm me-2 mb-2" @click="removeQuestion(question.id)">Delete</b-button>
                              </td>
                           </tr>
                 
                        </tbody>
                        <tbody v-else>
                           <tr>
                              <td colspan="6" class="text-center">No Questions found</td>
                           </tr>
                        </tbody>
                     </table>
                  </div>
            </div>
         </div>
         </div>
      </div>
       <!---- modal starts ---->
       <b-modal ref="symptom-modal" id="symptom-modal" :title="modal_title" hide-footer @hidden="clearForm()">
                     <b-form @submit.prevent="addQuestion()">                        
                        <div class="row"> 
                           <b-col md="12" class="form-group">
                           <label class="control-label">Question<span class="text-danger">*</span></label>
                           <b-form-input v-model="symptom.question" v-bind:class="{ 'is-invalid': Boolean(errors.question) }"></b-form-input>
                           <div v-for="(val, index) in errors.question" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                           </div>
                        </b-col>

                           <b-col md="12" class="mt-3">
                              <b-button type="submit" class="me-3" variant="primary">{{ button_title }}</b-button>
                              <b-button class="" variant="light" @click="hideModal('symptom-modal')">Close</b-button>
                           </b-col>
                        </div>                       
                     </b-form>
                  </b-modal>
                  <!---- modal ends ----->
   </Layout>
</template>
